import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { KeyRound, MailCheck } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useLang } from '@/context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { t } = useLang();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error(t('auth.enter_email')); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      toast.error(t('common.something_wrong'));
    }
    setLoading(false);
  };

  return (
    <div className="pt-20 min-h-screen flex items-center" data-testid="forgot-password-page">
      <div className="max-w-md mx-auto px-6 py-24 w-full">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <div className="text-center mb-10">
            {sent ? <MailCheck className="w-8 h-8 text-[#D4AF37] mx-auto mb-4" strokeWidth={1.5} /> : <KeyRound className="w-8 h-8 text-[#D4AF37] mx-auto mb-4" strokeWidth={1.5} />}
            <h1 className="text-3xl font-['Cormorant_Garamond'] font-bold text-[#F5F2EB] mb-2">{sent ? t('auth.check_email') : t('auth.forgot_title')}</h1>
            <p className="text-sm text-[#A3A19C]">
              {sent ? t('auth.sent_sub') : t('auth.forgot_sub')}
            </p>
          </div>
          {sent ? (
            <p className="text-center text-sm text-[#A3A19C]" data-testid="forgot-password-sent">
              {t('auth.didnt_get')} <button onClick={() => setSent(false)} className="text-[#D4AF37] hover:text-[#E5C07B]" data-testid="forgot-password-retry">{t('auth.try_again')}</button>.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
              <div>
                <label className="block text-sm text-[#A3A19C] mb-2">{t('common.email')}</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} data-testid="forgot-password-email"
                  className="w-full bg-[#121215] border border-[rgba(255,255,255,0.1)] rounded-lg px-4 py-3 text-[#F5F2EB] text-sm focus:outline-none focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] transition-colors duration-300"
                  placeholder="your@email.com" dir="ltr" />
              </div>
              <button type="submit" disabled={loading} className="w-full btn-primary" data-testid="forgot-password-submit">
                {loading ? t('contact.sending') : t('auth.send_link')}
              </button>
            </form>
          )}
          <p className="text-center text-sm text-[#A3A19C] mt-8">
            <Link to="/login" className="text-[#D4AF37] hover:text-[#E5C07B] transition-colors duration-300" data-testid="forgot-password-back-login">{t('auth.back_signin')}</Link>
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
